"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateRenderer = exports.bigintRenderer = exports.numberRenderer = exports.booleanRenderer = exports.undefinedRenderer = exports.nullRenderer = exports.stringRenderer = void 0;
/**
 * The renderer for string entries.
 *
 * @param entry A string of text.
 * @returns String content.
 */
const stringRenderer = (entry) => entry;
exports.stringRenderer = stringRenderer;
/**
 * The renderer for null entries.
 *
 * @param entry null
 * @returns an empty string
 */
const nullRenderer = (entry) => '';
exports.nullRenderer = nullRenderer;
/**
 * The renderer for undefined entries.
 *
 * @param entry undefined
 * @returns an empty string
 */
const undefinedRenderer = (entry) => '';
exports.undefinedRenderer = undefinedRenderer;
/**
 * The renderer for boolean entries.
 *
 * @param entry a boolean
 * @returns the boolean as a string
 */
const booleanRenderer = (entry) => entry.toString();
exports.booleanRenderer = booleanRenderer;
/**
 * The renderer for number entries.
 *
 * @param entry a number
 * @returns the number as a string
 */
const numberRenderer = (entry) => entry.toString();
exports.numberRenderer = numberRenderer;
/**
 * The renderer for bigint entries.
 *
 * @param entry a bigint
 * @returns the bigint as a string
 */
const bigintRenderer = (entry) => entry.toString();
exports.bigintRenderer = bigintRenderer;
/**
 * The renderer for date entries.
 *
 * @param entry a date
 * @returns the date as an ISO string.
 */
const dateRenderer = (entry) => entry.toISOString();
exports.dateRenderer = dateRenderer;
